export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14150.1c302d73.jpg";